module.exports = __webpack_public_path__ + "img/17863_L.6a9ce5ab.png";